<script lang="ts" setup>
	import type { ClassNameValue } from 'tailwind-merge'

	const config = {
		base: '',
		background: 'bg-current',
		rounded: 'rounded-lg',
		margin: ' mx-auto',
		width: 'max-w-[1240px] w-full',
		height: 'sm:max-h-[738px] h-full'
	}
	defineProps<{
		show: boolean
		closeBtnDisplay?: boolean
		ui?: Partial<typeof config>
	}>()

	defineEmits<{
		(event: 'update:show', payload: boolean): void
	}>()
	const attr = useAttrs()
	const className = computed(() => attr?.class as ClassNameValue)
	defineOptions({ inheritAttrs: false })
</script>

<template>
	<div>
		<u-modal
			:model-value="show"
			:ui="{
				wrapper: 'relative z-[600]',
				container: 'flex min-h-full items-center justify-center text-center',
				fullscreen: cn(
					`w-full max-w-[1240px] gap-3 xl:gap-10 items-center pt-10 z-[700] md:overflow-visible overflow-y-auto p-2 sm:p-5 bg-transparent ${
						ui?.height ?? config.height
					}`,
					className
				),
				background: '!bg-transparent',
				shadow: '',
				overlay: {
					background: 'bg-gray-600/75'
				}
			}"
			aria-label="dialog"
			fullscreen
			:prevent-close="false"
			@close="$emit('update:show', false)"
		>
			<button
				v-if="!closeBtnDisplay"
				class="realative inline-flex rounded-full relative z-10 bg-current active:scale-75 custom-transition-2 flex-none dark:bg-gray-900 items-center justify-center sm:h-[50px] sm:w-[50px] w-[40px] h-[40px]"
				type="button"
				aria-label="close dialog"
				@click="$emit('update:show', false)"
			>
				<tools-icon dir="line" icon="crosshair" svg-class="rotate-45 sm:h-[16px] h-[14px]" />
			</button>

			<div
				class="flex-1"
				:class="
					cn(
						ui?.background ?? config?.background,
						ui?.margin ?? config.margin,
						ui?.rounded ?? config.rounded,
						ui?.width ?? config.width,
						ui?.base ?? ''
					)
				"
			>
				<slot />
			</div>
		</u-modal>
	</div>
</template>
